import { format, formatDistance, formatRelative, parseISO } from 'date-fns';
import * as localesData from 'date-fns/locale';
import { getDefaultLangFromLocalStorage } from './functions';

const supportedLanguages = process.env.REACT_APP_SUPPORTED_LANGUAGES?.split(
  ',',
) || ['enUS'];

let defaultLang = getDefaultLangFromLocalStorage();
defaultLang = defaultLang === 'en-US' ? 'enUS' : defaultLang;

const locales = supportedLanguages.reduce((acc, lang) => {
  lang = lang === 'en-US' ? 'enUS' : lang;

  if (localesData[lang]) {
    acc[lang] = localesData[lang];
  }
  return acc;
}, {});

const selectedLocale = locales[defaultLang] || localesData['enUS'];

export const formatCommentDate = (date) => {
  return formatDistance(parseISO(date), new Date(), {
    addSuffix: true,
    locale: selectedLocale,
  });
};

export const formatPublishedAgoDate = (date) => {
  return formatDistance(parseISO(date), new Date(), {
    addSuffix: true,
    locale: selectedLocale,
  });
};

export const formatPublishDateFull = (date) => {
  return format(parseISO(date), 'dd/MM/yyyy hh:mm a');
};

export const formatLikeCalendar = (date) => {
  return formatRelative(parseISO(date), new Date());
};

export const formatDiagnosisDate = (date) => {
  return format(parseISO(date), 'dd/MM/yyyy');
};
